import { AppStartupStatus } from "app";
import { AppModule } from "components/appModules/appModule";
import i18n from "components/i18n/i18n";
import { Router } from "components/router/router";

declare const __BUILDTIME__: string;
export class AppModuleRegistry {
    public apps: AppModule[] = [];
    /** Get external apps. All apps except core. */
    public nonCoreApps: AppModule[] = [];
    public currentApp: AppModule;

    public register(module: AppModule, appStartupStatus: AppStartupStatus): void {
        this.apps.push(module);
        if (module.prefix !== '') {
            i18n.loadRemoteNamespace(
                module.prefix,
                module.resourcesUrl + "/locales/{{lng}}/translations.json?v=" + __BUILDTIME__,
                appStartupStatus.setStarted);
            this.nonCoreApps.push(module);
        }
        Router.getInstance(appStartupStatus).createAppRoute(module);
    }

    public prefixUrl = (url: string): string => {
        const splitted = url.split(":", 2);
        if (splitted.length > 1) {
            let baseUrl;
            for (const app of this.apps) {
                if (app.prefix === splitted[0]) {
                    baseUrl = app.baseUrl;
                    break;
                }
            }
            return baseUrl + splitted[1];
        } else {
            return url;
        }
    }
}

const appModuleRegistry = new AppModuleRegistry();
export default appModuleRegistry;